import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import ActivityLogTable from "../../../components/DailyReport/activityLog"

const ActivityLogs = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Activity Log | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <ActivityLogTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ActivityLogs
